import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { firstValueFrom } from "rxjs";
import { PRODUCTIVITE_MOYENNE_DATA } from "../../models/data.model";
import { SharedModule } from "../../../../shared/shared.module";
import { WidgetHelperService } from "../../services/widget-helper.service";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";
import { Widget } from "../../models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { RangePipe } from "../../../../shared/pipes/range.pipe";
import { ChipsComponent } from "../../../../shared/modules/chips/chips.component";
import { DialogsService } from "../../../../shared/services/dialogs/dialogs.service";
import { ProductiviteDialogComponent } from "./productivite-dialog.component";

@Component({
  selector: "vl-widget-productivite-moyenne",
  standalone: true,
  imports: [SharedModule, WidgetTitleComponent, RangePipe, ChipsComponent],
  templateUrl: "./widget-productivite-moyenne.component.html",
  styleUrl: "./widget-productivite-moyenne.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetProductiviteMoyenneComponent {
  data = input<PRODUCTIVITE_MOYENNE_DATA>();
  metadata = input<EntityMetadata>();
  widget = input<Widget>();

  private dialogs = inject(DialogsService);

  dataDisplay = computed(() =>
    WidgetHelperService.getProductiviteData(this.data()?.data),
  );

  totalCount = computed(() => this.dataDisplay()?.length ?? 0);

  async onSeeAll(): Promise<void> {
    const ref = this.dialogs.open(
      ProductiviteDialogComponent,
      undefined,
      undefined,
      {
        rows: this.dataDisplay() ?? [],
        ofs: this.data()?.data?.ofs ?? [],
      },
    );
    await firstValueFrom(ref.afterClosed());
  }
}
